"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const useOnLoad_1 = __importDefault(require("../../hooks/useOnLoad"));
const useControlEvents_1 = __importDefault(require("../../../hooks/useControlEvents"));
const BannerAdRenderer = ({ bannerControl, }) => {
    var _a;
    const { Render, functions: { processor }, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const events = (0, useControlEvents_1.default)(bannerControl);
    (0, useOnLoad_1.default)(bannerControl, events);
    const onAdClosed = (0, react_1.useCallback)(() => {
        if (events === null || events === void 0 ? void 0 : events.onAdClosed) {
            events.onAdClosed();
        }
    }, [events]);
    const onAdFailedToLoad = (0, react_1.useCallback)(() => {
        if (events === null || events === void 0 ? void 0 : events.onAdFailedToLoad) {
            events.onAdFailedToLoad();
        }
    }, [events]);
    const onAdLeftApplication = (0, react_1.useCallback)(() => {
        if (events === null || events === void 0 ? void 0 : events.onAdLeftApplication) {
            events.onAdLeftApplication();
        }
    }, [events]);
    const onAdLoaded = (0, react_1.useCallback)(() => {
        if (events === null || events === void 0 ? void 0 : events.onAdLoaded) {
            events.onAdLoaded();
        }
    }, [events]);
    const onAdOpened = (0, react_1.useCallback)(() => {
        if (events === null || events === void 0 ? void 0 : events.onAdOpened) {
            events.onAdOpened();
        }
    }, [events]);
    const unitId = (0, react_1.useMemo)(() => {
        var _a;
        const platform = (_a = processor === null || processor === void 0 ? void 0 : processor.root) === null || _a === void 0 ? void 0 : _a.platformOS;
        if (platform === 'android') {
            return bannerControl === null || bannerControl === void 0 ? void 0 : bannerControl.androidAdUnitId;
        }
        return bannerControl === null || bannerControl === void 0 ? void 0 : bannerControl.iosAdUnitId;
    }, [
        (_a = processor === null || processor === void 0 ? void 0 : processor.root) === null || _a === void 0 ? void 0 : _a.platformOS,
        bannerControl === null || bannerControl === void 0 ? void 0 : bannerControl.androidAdUnitId,
        bannerControl === null || bannerControl === void 0 ? void 0 : bannerControl.iosAdUnitId,
    ]);
    return (react_1.default.createElement(Render.BannerAd, { unitId: unitId, size: (bannerControl === null || bannerControl === void 0 ? void 0 : bannerControl.size) || 'ADAPTIVE_BANNER', onAdClosed: onAdClosed, onAdFailedToLoad: onAdFailedToLoad, onAdLeftApplication: onAdLeftApplication, onAdLoaded: onAdLoaded, onAdOpened: onAdOpened, requestOptions: {
            requestNonPersonalizedAdsOnly: bannerControl === null || bannerControl === void 0 ? void 0 : bannerControl.requestNonPersonalizedAdsOnly,
        } }));
};
exports.default = BannerAdRenderer;
